import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { ZemplinLoaderWrapper } from '../../..';
import { DsiProductList as ProductList } from '../Product/ProductList';
import { DsiFavoriteCategory as FavoriteCategory } from '../Home/FavoriteCategory';

interface Props {
  isFetching: boolean;
  apiUrl: string;
  products: any;
  categories: any;
  addToCart: any;
  addToRequest: any;
}

function Favorites({
  isFetching,
  apiUrl,
  products,
  categories,
  addToCart,
  addToRequest,
}: Props) {
  const add = () => {
    return;
  };
  return (
    <Wrapper>
      <SubTitle>{`${__('Obľúbené produkty')}`}</SubTitle>
      {isFetching ? (
        <ZemplinLoaderWrapper height={500} />
      ) : (
        <>
          <ProductList
            addToFavorite={add}
            addToCart={addToCart}
            addToRequest={addToRequest}
            apiUrl={apiUrl}
            products={products}
            isFetching={isFetching}
          />
        </>
      )}
      <FavoriteCategory categories={categories} />
    </Wrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  animation: ${animateIn} 0.2s ease;

  ${({ theme }) => theme.mediab.m810`
      margin-right: -${rem(16)};
  `};
`;

export const SubTitle = styled.h2`
  font-size: ${rem(30)};
  font-weight: 400;
  margin-top: 0;
  margin-bottom: ${rem(32)};
`;

export { Favorites as DsiFavorites };
